import React from 'react';
import { CustomButton } from '@/components/ui/CustomButton';
import Captcha from '@/components/Captcha';
import { PersonalDetailsSection } from './components/PersonalDetailsSection';
import { ClubMembershipSection } from './components/ClubMembershipSection';
import { BankDetailsSection } from './components/BankDetailsSection';
import { SignatureSection } from './components/SignatureSection';
import { HearAboutUsSection } from './components/HearAboutUsSection';
import { LoadingModal } from './components/LoadingModal';

export const Step3Form = ({
  formData,
  handleInputChange,
  handleSelectChange,
  handleSubmitClick,
  isSubmitting,
  errors,
  setErrors,
  setIsCaptchaValid,
  setTurnstileToken,
  setErrorMessage,
  errorMessage,
}) => (
  <>
    <h1 className="text-[#373945] text-4xl font-semibold mb-6 text-left lg:text-center lg:mb-12">
      Personal information
    </h1>

    <p className="text-[#5B5D6B] text-base font-450 mb-12 lg:hidden">
      <span className="font-bold">Step 3:</span> Last few details, then we will send you your secure password and
      log in instructions by email.
    </p>

    <PersonalDetailsSection
      formData={formData}
      handleInputChange={handleInputChange}
      errors={errors}
    />

    <ClubMembershipSection
      formData={formData}
      handleSelectChange={handleSelectChange}
      handleInputChange={handleInputChange}
      errors={errors}
    />

    <BankDetailsSection
      formData={formData}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      errors={errors}
    />

    <SignatureSection
      formData={formData}
      handleInputChange={handleInputChange}
      errors={errors}
    />

    <HearAboutUsSection
      formData={formData}
      handleSelectChange={handleSelectChange}
      handleInputChange={handleInputChange}
      errors={errors}
    />

    <div className="mb-12 p-6 bg-[#F3F4F8] bg-opacity-75 rounded-lg">
      <div className="flex gap-2 mb-2">
        <img src="/img/icons/key-01.svg" className="w-6 h-6" alt="Key info" />
        <span className="text-[#373945] text-base font-semibold">Watch for a Password in your Inbox</span>
      </div>

      <p className="text-[#373945] text-sm font-medium">
          You&#39;ll receive a secure password and login instructions as soon as our verification checks are complete.
      </p>
    </div>

    <Captcha
      onValidationChange={setIsCaptchaValid}
      setTurnstileToken={setTurnstileToken}
      setErrorMessage={setErrorMessage}
    />

    {errorMessage && (
      <div className="mb-3 text-red-500 text-sm">{errorMessage}</div>
    )}

    <LoadingModal isSubmitting={isSubmitting} />

    <CustomButton
      variant="primaryLarge"
      type="button"
      className="disabled:opacity-50 disabled:cursor-not-allowed w-full md:w-3/4 md:mx-auto mb-12"
      onClick={() => {
        handleSubmitClick();
      }}
    >
      {isSubmitting
        ? <img
          src="/img/icons/refresh-gray.svg"
          alt="Submitting"
          className="w-5 h-5 animate-spin"
        />
        : 'Submit'
      }
    </CustomButton>
  </>
);
